module.exports = __webpack_public_path__ + "774e50c3dd64fd7f63a07d5d37f4d67f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-18.png
// module id = 2077
// module chunks = 0